import { ToastContainer, Slide, Zoom, Flip, Bounce } from "react-toastify";

const Toast = () => {
  return (
    <ToastContainer
      position="bottom-right"
      autoClose={2000}
      transition={Flip}
      hideProgressBar={true}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
    />
  );
};

export default Toast;
